export const addFlexBackofficeSuffix = (...s: string[]) => {
  return s.concat('FlexBackOffice').join(' - ');
};
